import { render } from "./OrderPriorityTimes.vue?vue&type=template&id=9efa4456&ts=true"
import script from "./OrderPriorityTimes.vue?vue&type=script&lang=ts"
export * from "./OrderPriorityTimes.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__